import { PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { useAuth } from "./useAuth";

type Props = PropsWithChildren;

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading && !isAuthenticated) {
    return;
  }

  return isAuthenticated ? children : <Navigate to="/auth/login" />;
}
